<div class="confirmation-modal" [class.confirmation-modal--shown]="shown" tabindex="-1" role="dialog" id="app-confirmation-modal">
  <div class="confirmation-modal__dialog" role="document">
    <div class="confirmation-modal__content">
      <div class="confirmation-modal__header">
        <button
          type="button"
          class="confirmation-modal__close"
          aria-label="Close"
          (click)="shown = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="confirmation-modal__title">
          {{ confirmation.title }}
        </h4>
      </div>
      <div class="confirmation-modal__body">
        <div [innerHTML]="sanitize(confirmation.message)"></div>
      </div>
      <div class="confirmation-modal__footer">
        @for (button of confirmation.buttons; track button) {
          <app-cmn-button
            type="button"
            size="small"
            [buttonClass]="button.styleClass"
            (buttonClick)="handleButtonClick(button)"
          >
            {{ button.text }}
          </app-cmn-button>
        }
      </div>
    </div>
  </div>
</div>
